import config from '../config'
import CoreServices from './coreServices'
import { USERS } from '../constants/services'
import axios from 'axios'

class UserServices extends CoreServices {
  async changeAvatar(args) {
    let headers = {
    }

    try {
      let res = await axios.post(`${this.apiEnpointV1}/users/change-avatar`,
        args, {
        headers: headers
      })

      let data = await res.data.data

      return data
      return 
    } catch (error) {
      return { error }
    }
  }

  async guestChangeAvatar(args) {
    let headers = {
    }

    try {
      let res = await axios.post(`${this.apiEnpointV1}/guests/change-avatar`,
        args, {
        headers: headers
      })

      let data = await res.data.data

      return data
      return 
    } catch (error) {
      return { error }
    }
  }

  async changeLocale(args) {
    try {
      let response = await axios.put(`${this.apiEnpointV1}/users/change-locale`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async changeLanguage(args) {
    try {
      let response = await axios.put(`${this.apiEnpointV1}/users/change-language`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async requestMonetization() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/request-monetization`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async agreementMonetization(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/agreement-monetization`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async confirmDocument() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/confirm-documents`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  getProfile(sessionId = null) {
    // Collapse overlapping profile lookups into a single in-flight request so
    // callers firing around the same time (page mount + PrivateRoute, payment
    // refresh, etc.) don't each hit /profile (N+1). The promise is cleared once
    // it settles, so the next call still fetches fresh data — nothing is cached.
    if (this._profileRequest) {
      return this._profileRequest
    }

    let lang = window.navigator ? navigator.language : ''

    this._profileRequest = axios.get(`${this.apiEnpointV1}/profile?lang=${lang}&device=web&session=${sessionId}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response?.data?.data ?? {})
      .catch((error) => ({ error }))
      .finally(() => {
        this._profileRequest = null
      })

    return this._profileRequest
  }

  async updateProfile(args) {
    try {
      let response = await axios.put(`${this.apiEnpointV1}/profile`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async changeGender(gender) {
    try {
      let response = await axios.put(`${this.apiEnpointV1}/users/change-gender`, { gender: gender }, {
        headers: {
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async changePassword(args) {
    try {
      let response = await axios.put(`${this.apiEnpointV1}/users/change-password`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async verifyGender(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/verify-gender`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async uploadDocument(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/upload-document`, args, {
        headers: {
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async withdraw(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/payments/withdraw`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async sendConfirmEmail(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/send-confirm-email`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return response.data
    } catch (error) {
      return { error }
    }
  }

  async verifyEmail(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/verify-email`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return response.data
    } catch (error) {
      return { error }
    }
  }

  async unsubscribeEmail(token) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/unsubscribe-email`, { token: token }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return {}
    } catch (error) {
      return { error }
    }
  }

  async ping() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/ping`, { }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return {}
    } catch (error) {
      return { error }
    }
  }

  async support(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/support`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return true
    } catch (error) {
      return false
    }
  }

  async getRates() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/users/rates`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getReferrals() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/users/referrals`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async suspend() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/suspend?device=web`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      return {}
    } catch (error) {
      return { error }
    }
  }

  async changeNotification(args) {
    try {
      let response = await axios.put(`${this.apiEnpointV1}/users/notifications`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async endSearching() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/end-search`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      return {}
    } catch (error) {
      return { error }
    }
  }

  async getNotices(queries) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/users/notices`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        params: queries
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }
  
  async getTotalNotices() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/users/unread-notices`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getVerifyAgeLink() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/users/verify-age-link`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getDocumentVerificationLink() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/users/document-verification-link`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getIdentifyVerificationLink() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/users/identify-verification-link`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getBlockedUsers() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/users/blocks`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async unblock(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/unblock`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async fingerprint(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/fingerprints`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  // Records acceptance of the camera participation terms. The server keeps the
  // log entry and only accepts the first submission, so this is safe to retry.
  async cameraConsent() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/camera-consent`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  // Audit trail for a passed gesture liveness check. The pass itself is decided
  // on the client, so this only records that it happened — it is not a gate, and
  // callers must not block the model on its result.
  async logGestureVerification({ gestures } = {}) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/gesture-verification`, {
        gestures,
      }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new UserServices(USERS.BASE)
